import { createSlice } from "@reduxjs/toolkit";
import { getAbout, updateAbout } from "actions/about";

const initialState = {
  loading: false,
  about: null,
  updateLoading: false,
  error: null,
};

export const aboutSlice = createSlice({
  name: "about",
  initialState,
  reducers: {
    clearAbout: (state) => {
      state.about = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAbout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAbout.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.about = payload;
      })
      .addCase(getAbout.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(updateAbout.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateAbout.fulfilled, (state, { payload }) => {
        state.updateLoading = false;
        state.about = payload;
      })
      .addCase(updateAbout.rejected, (state, { payload }) => {
        state.updateLoading = false;
        state.error = payload;
      });
  },
});

export const { clearAbout, clearError } = aboutSlice.actions;

export default aboutSlice.reducer;
